import { render, staticRenderFns } from "./DocumentOrders.vue?vue&type=template&id=15af67f8"
import script from "./DocumentOrders.vue?vue&type=script&lang=js"
export * from "./DocumentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports